import React, { useEffect, useState } from "react";
import { Bell, X, Share, Loader2, Smartphone } from "lucide-react";
import { toast } from "sonner";
import * as pushLib from "../../lib/pushClient";

const SNOOZE_KEY = "pozzo_push_prompt_snooze";
const snoozed = () => Number(localStorage.getItem(SNOOZE_KEY) || 0) > Date.now();

// Shown under the admin header until Web Push is enabled on this device.
export function PushPromptBanner() {
  const [state, setState] = useState("hidden"); // hidden | prompt | ios-install
  const [busy, setBusy] = useState(false);

  const check = async () => {
    if (!pushLib.pushSupported() && !pushLib.iosNeedsInstall()) return setState("hidden");
    if (snoozed()) return setState("hidden");
    if (pushLib.iosNeedsInstall()) return setState("ios-install");
    const sub = await pushLib.getPushSubscription().catch(() => null);
    setState(sub ? "hidden" : "prompt");
  };
  useEffect(() => { check(); window.addEventListener("pozzo-push-changed", check); return () => window.removeEventListener("pozzo-push-changed", check); }, []);

  const enable = async () => {
    setBusy(true);
    try { await pushLib.enablePush([]); window.dispatchEvent(new Event("pozzo-push-changed")); toast.success(`Notifiche attive su questo ${pushLib.deviceLabel()}`); setState("hidden"); }
    catch (e) { toast.error(e?.response?.data?.detail || e.message || "Errore"); }
    finally { setBusy(false); }
  };
  const snooze = () => { localStorage.setItem(SNOOZE_KEY, String(Date.now() + 7 * 86400e3)); setState("hidden"); };

  if (state === "hidden") return null;
  return (
    <div className="bg-[#fdf6e9] border-b border-[#C48B31]/40 text-[#2b1410]" data-testid="push-prompt-banner" data-state={state}>
      <div className="max-w-6xl mx-auto px-3 sm:px-4 py-2 flex items-center gap-3">
        <div className="h-8 w-8 rounded-full bg-[#C48B31] text-white flex items-center justify-center shrink-0">{state === "ios-install" ? <Smartphone className="h-4 w-4" /> : <Bell className="h-4 w-4" />}</div>
        <div className="flex-1 min-w-0 text-xs sm:text-sm">
          {state === "ios-install" ? (
            <><b>Su iPhone le notifiche funzionano solo dall'app installata.</b> Tocca <Share className="inline h-3.5 w-3.5 -mt-0.5" /> <b>Condividi</b> → <b>Aggiungi alla schermata Home</b>, poi apri il pannello da lì e attiva le notifiche.</>
          ) : (
            <><b>Ricevi prenotazioni, ordini shop, asporto, regali e cavallo su questo telefono</b> anche con l'app chiusa.</>
          )}
        </div>
        {state === "prompt" && (
          <button onClick={enable} disabled={busy} data-testid="push-prompt-enable" className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-[#4a1c17] text-[#f7ebdf] px-3 py-1.5 text-xs font-semibold disabled:opacity-60">
            {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Bell className="h-3.5 w-3.5" />} Attiva notifiche
          </button>
        )}
        <button onClick={snooze} title="Ricordamelo tra una settimana" data-testid="push-prompt-snooze" className="shrink-0 h-7 w-7 rounded-full hover:bg-[#C48B31]/20 flex items-center justify-center"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
